import { isClientSideShopApp } from '@/utils/navigator'

/**
 * GA / 追蹤事件上的 platform 值。
 * 之後若要調整 GA 上的命名，只需改這裡，所有事件即同步更新。
 */
export const PLATFORM = {
  APP: 'app',
  WEB: 'web',
} as const

export type Platform = (typeof PLATFORM)[keyof typeof PLATFORM]

/** 依執行環境回傳 platform 值（client-side shop app 為 app，其餘為 web）。 */
export const getPlatform = (): Platform => (isClientSideShopApp ? PLATFORM.APP : PLATFORM.WEB)
